export const triangleDown = () => (
  <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M5.5 6L0.736861 -8.97232e-07L10.2631 -6.44184e-08L5.5 6Z" fill="currentColor" />
  </svg>
);
